<script>
    import { handleScoopAjaxError } from '../../mixins/axios-response-errors'
    import { modelToolHelpers } from '../../mixins/model-tool-helpers'

    export default {
        mixins: [
            modelToolHelpers('ScoopModelSelectorToolsMoveMedia')
        ],
        data() {
            return {
                loading: true,
                index: null,
                directory: null,
                medias: [],
                tree: [],
            }
        },
        methods: {
            openModal() {
                this.fetchMedias();
                this.$refs.openTemplate.click();
            },
            fetchMedias() {
                this.loading = true;
                axios.get('/mediaserver/media').then((response) => {
                    this.medias = response.data;

                    this.fetchDirectories();
                });
            },
            fetchDirectories() {
                this.loading = true;
                axios.get('/mediaserver/directory').then((response) => {
                    this.tree = response.data;
                    this.loading = false;
                });
            },
            initializeTree() {
                this.$nextTick(() => {
                    $('#jstree-move-media').jstree({
                        'core': {
                            'themes': {
                                'name': 'proton',
                                'responsive': true
                            },
                            'multiple': false,
                            'check_callback': true
                        }
                    });
                    $('#jstree-move-media').on("changed.jstree", function (e, data) {
                        if (data.node) {
                            this.setIndexAndDirectory(data.node.id);
                        }
                    }.bind(this));
                });
            },
            setIndexAndDirectory(json) {
                _.forEach(JSON.parse(json), (value, key) => {
                    if (key === 'count') {
                        return;
                    }
                    this[key] = value || '';
                });
            },
            moveFiles() {
                this.loading = true;

                axios.post('/mediaserver/media/move', {
                    index: this.index,
                    directory: this.directory,
                    medias: this.mediaSelected,
                }).then(response => {
                    window.location.reload();
                }).catch(error => {
                    handleScoopAjaxError(error);
                    this.loading = false;
                });
            },
        },
        computed: {
            mediaSelected: {
                get: function () {
                    return scoopOS.getSelected('medias');
                },
                set: function (newValue) {
                    scoopOS.replaceAll('medias', newValue);
                }
            },
            count() {
                return this.countApplicableModels();
            },
            isVisible() {
                return this.allowedToSee();
            },
            indexHasDirectories() {
                if (this.filteredTree) {
                    return _.keys(this.filteredTree.children).length > 0;
                }

                return false;
            },
            filteredTree() {
                return this.tree;
                // return _.find(this.tree.children, node => {
                //     node = JSON.parse(node.value);
                //
                //     return this.index === node.index;
                // });
            },
            directoryReadable() {
                return this.index + (this.directory ? this.directory.split('::').join('/') : '');
            },
            mediasPreview() {
                return _.slice(this.medias, 0, 10);
            }
        },
        watch: {
            loading() {
                if (!this.loading) {
                    this.$nextTick(() => {
                        this.initializeTree();
                    });
                }
            }
        }
    }
</script>

<template>
    <a id="move-media-icon" class="count-info" v-if="isVisible" @click="openModal">
        <portal to="modals">
            <Lightbox
                    id="moveMediaModal"
                    headline="Move selected media"
                    :subheadline="count + ' medias selected'"
                    large="true"
            >
                <span slot="open-template" ref="openTemplate"></span>
                <div slot="body" class="row m-b" v-if="loading">
                    <div class="text-center p-m">
                        <span>Loading</span>
                        <i class="fa fa-cog fa-spin"></i>
                    </div>
                </div>
                <div slot="body" v-else>
                    <div class="ibox m-b-sm">
                        <div class="ibox-title">
                            <strong>Move to directory</strong>
                        </div>
                        <div class="ibox-content">
                            <div id="jstree-move-media">
                                <ul>
                                    <tree-node
                                            class="jstree-open"
                                            :node="filteredTree"
                                            :children-collapsed="true"
                                            v-if="filteredTree"
                                    ></tree-node>
                                </ul>
                            </div>
                            <div class="alert alert-warning" role="alert" v-show="!indexHasDirectories">
                                <p>The selected index has no directories</p>
                            </div>
                        </div>
                    </div>

                    <div class="ibox m-b-none" v-if="directory !== null">
                        <div class="ibox-content lh-34">
                            Move selected files to <code>{{ directoryReadable }}</code>
                            <button class="btn btn-primary pull-right" @click="moveFiles">Start process <i
                                    class="fa fa-copy"></i></button>
                        </div>
                        <div class="ibox-content lh-34">
                            <h4>{{ count }} affected files</h4>
                            <p class="m-b-none" v-for="media in mediasPreview">
                                <i class="fa fa-long-arrow-right" aria-hidden="true"></i>
                                <code>{{ media.index_id + media.directory + '/' + media.filename }}</code><br>
                            </p>
                            <template v-if="mediasPreview.length < medias.length">
                                <p>
                                    and {{ (medias.length - mediasPreview.length) }} more files
                                </p>
                            </template>
                        </div>
                    </div>
                </div>
            </Lightbox>
        </portal>

        <i class="fa fa-copy"></i>
    </a>
</template>
